/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ConfigSectionComponent} from "@app/models/components/config-section.component";
import {QUERY_PARAM_DIABETES_WIZARD_CONFIGS} from "@app/models/constants/routing-constants";
import {TpConfigsInfo} from "@doctor-panel-modules/patient-treatment-plan/models/tp-sections-info";
import {TpService} from "@doctor-panel-modules/patient-treatment-plan/services/tp.service";
import {PatientTreatmentPlanAdvState} from "@modules/doctor-panel/modules/patient-treatment-plan/store/patient-treatment-plan-adv.state";
import {Select} from "@ngxs/store";
import {TrecApiError, TrecError} from "@trec/api/errors";
import {Observable, Subscription} from "rxjs";

@Component({
  selector: "c3-tp-advanced-page",
  templateUrl: "./tp-advanced.page.html",
  styleUrls: ["./tp-advanced.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TpAdvancedPage implements OnInit, OnDestroy {
  @Select(PatientTreatmentPlanAdvState.error) error$: Observable<TrecError | TrecApiError | null>;

  @ViewChildren("configSection")
  configSections: QueryList<ConfigSectionComponent>;

  /**
   * List of config sections to show. If null, all section will be shown.
   */
  wizardSelectedConfigIds: string[] = [];

  currentShownConfigs: TpConfigsInfo | null = null;

  private readonly subscr = new Subscription();

  constructor(private route: ActivatedRoute, protected tpService: TpService) { }

  ngOnInit() {
    this.wizardSelectedConfigIds =
      this.route.snapshot.queryParamMap.getAll(QUERY_PARAM_DIABETES_WIZARD_CONFIGS) || [];

    this.subscr.add(
      this.tpService.getCurrentSubScection("advanced").subscribe((currConfig) => {
        this.currentShownConfigs = currConfig;
      })
    );
  }

  showConfig(configId: string): boolean {
    // Decide whether show the config section if selectedCOnfigIds are present
    // If selectedConfigIds is missing -> always show the config section
    const wizardDecision =
      this.wizardSelectedConfigIds.length > 0
        ? this.wizardSelectedConfigIds.includes(configId)
        : true;
    const curreSetupDecision = !!this.currentShownConfigs?.[configId];

    return wizardDecision && curreSetupDecision;
  }

  ngOnDestroy() {
    this.subscr.unsubscribe();
  }
}
